import React from "react";
import "./ShowSupplier.scss";
import AnimatedCard from "../../../components/molecules/AnimatedCard/AnimatedCard";

const ShowSupplier = ({ data, onClose }) => {
    return (
        <AnimatedCard
            setClose={onClose}
            // title={data.name}
            size="lg"
            variant="elegant"
            showHeader={false}
            coloredHeader={false}
            closeOnBackdropClick={true}
            showCloseButton={true}
        >
            <div className="show-supplier">
                <div className="show-supplier__header">
                    <div className="show-supplier__header-left">
                        {data.imageUrl && (
                            <img
                                src={data.imageUrl}
                                alt={data.name}
                                className="show-supplier__image"
                            />
                        )}
                        <div className="show-supplier__contentHea">
                            <h2 className="show-supplier__title">
                                {data.name}
                            </h2>
                            {data.pdfUrl && (
                                <div className="show-supplier__item">
                                    {/* <span className="show-supplier__label">
                                    PDF:
                                </span> */}
                                    <a
                                        href={
                                            data.pdfUrl.startsWith("http")
                                                ? data.pdfUrl
                                                : `https://${data.pdfUrl}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="show-supplier__link-pdf"
                                    >
                                        <i className="pi pi-file-pdf"></i>{" "}
                                        {data.pdfUrl
                                            .split("/")
                                            .pop()
                                            ?.split("?")[0] || "Ver PDF"}
                                        {"    "}
                                        <i className="pi pi-external-link"></i>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                    {data.isActive && (
                        <span className="show-supplier__badge show-supplier__badge--active">
                            Activo
                        </span>
                    )}
                </div>

                <div className="show-supplier__body">
                    {/* Información de contacto */}
                    <div className="show-supplier__section">
                        <h3 className="show-supplier__subtitle">
                            Información de Contacto
                        </h3>
                        <div className="show-supplier__grid">
                            {data.email && (
                                <div className="show-supplier__item">
                                    <span className="show-supplier__label">
                                        Email:
                                    </span>
                                    <span className="show-supplier__value">
                                        {data.email}
                                    </span>
                                </div>
                            )}
                            {data.whatsapp && (
                                <div className="show-supplier__item">
                                    <span className="show-supplier__label">
                                        WhatsApp:
                                    </span>
                                    <span className="show-supplier__value">
                                        {data.whatsapp}
                                    </span>
                                </div>
                            )}
                            {data.address && (
                                <div className="show-supplier__item">
                                    <span className="show-supplier__label">
                                        Dirección:
                                    </span>
                                    <span className="show-supplier__value">
                                        {data.address}
                                    </span>
                                </div>
                            )}
                            {data.location && (
                                <div className="show-supplier__item">
                                    <span className="show-supplier__label">
                                        Ubicación:
                                    </span>
                                    <span className="show-supplier__value">
                                        {data.location}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Horario de atención */}
                    {(data.businessHoursStart || data.businessHoursEnd) && (
                        <div className="show-supplier__section">
                            <h3 className="show-supplier__subtitle">
                                Horario de Atención
                            </h3>
                            <div className="show-supplier__grid">
                                <div className="show-supplier__item">
                                    <span className="show-supplier__label">
                                        Horario:
                                    </span>
                                    <span className="show-supplier__value">
                                        {data.businessHoursStart} -{" "}
                                        {data.businessHoursEnd}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Redes sociales */}
                    {(data.facebook ||
                        data.instagram ||
                        data.tiktok ||
                        data.website) && (
                        <div className="show-supplier__section">
                            <h3 className="show-supplier__subtitle">
                                Redes Sociales
                            </h3>
                            <div className="show-supplier__grid">
                                {data.facebook && (
                                    <div className="show-supplier__item">
                                        <span className="show-supplier__label">
                                            Facebook:
                                        </span>
                                        <a
                                            href={`${data.facebook}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="show-supplier__link"
                                        >
                                            {data.facebook}
                                        </a>
                                    </div>
                                )}
                                {data.instagram && (
                                    <div className="show-supplier__item">
                                        <span className="show-supplier__label">
                                            Instagram:
                                        </span>
                                        <a
                                            href={`${data.instagram}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="show-supplier__link"
                                        >
                                            {data.instagram}
                                        </a>
                                    </div>
                                )}
                                {data.tiktok && (
                                    <div className="show-supplier__item">
                                        <span className="show-supplier__label">
                                            TikTok:
                                        </span>
                                        <a
                                            href={`${data.tiktok}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="show-supplier__link"
                                        >
                                            {data.tiktok}
                                        </a>
                                    </div>
                                )}
                                {data.website && (
                                    <div className="show-supplier__item">
                                        <span className="show-supplier__label">
                                            Sitio Web:
                                        </span>
                                        <a
                                            href={`${data.website}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="show-supplier__link"
                                        >
                                            {data.website}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Grupos */}
                    {data.groups && data.groups.length > 0 && (
                        <div className="show-supplier__section">
                            <h3 className="show-supplier__subtitle">
                                Categorías
                            </h3>
                            <div className="show-supplier__tags">
                                {data.groups.map((group) => (
                                    <span
                                        key={group.id}
                                        className="show-supplier__tag"
                                    >
                                        {group.name}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </AnimatedCard>
    );
};

export default ShowSupplier;
